<template>
  <div class="person-block">
    <div
      v-if="contact"  
      class="member-block-form"
    >
      <b-form
        class="person-form"
        @submit.stop.prevent="onSubmit"
      >
        <b-row>
          <b-col>
            <h5>{{title}}</h5>
          </b-col>
        </b-row>
        <b-row v-if="subtitle">
          <b-col>
            <h6>{{subtitle}}</h6>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="Name:"
              class="vtd-form-group"
            >
              <b-form-input
                v-model.trim="$v.form.name.$model"
                type="text"
                class="vtd-form-control vtd-form-control-lg "
                :state="validateState('name')"
              />
            </b-form-group>  
          </b-col>
        </b-row>
        <b-row>  
          <b-col>
            <b-form-group
              label="Job Title:"
              class="vtd-form-group"
            >
              <b-form-input
                v-model="$v.form.job_title.$model"
                type="text"
                class="vtd-form-control vtd-form-control-lg "
                :state="validateState('job_title')"
              />
            </b-form-group>    
          </b-col>
        </b-row>
        <b-row>  
          <b-col>
            <b-form-group
              label="Email:"
              class="vtd-form-group"
            >
              <b-form-input
                v-model="$v.form.email.$model"
                type="text"
                class="vtd-form-control vtd-form-control-lg "
                :state="validateState('email')"
              />
            </b-form-group>   
          </b-col>
        </b-row>
        <b-row>  
          <b-col>
            <b-form-group
              label="Telephone:"
              class="vtd-form-group"
            >
              <b-form-input
                v-model="$v.form.telephone.$model"
                type="text"
                class="vtd-form-control vtd-form-control-lg "
                :state="validateState('telephone')"
              />
            </b-form-group>      
          </b-col>
        </b-row>
        <b-row v-if="deleteContact">
          <b-col>
            <b-button 
              type="button"
              class="vtd-btn vtd-btn-primary"
              @click="deleteContact"
            >
              Delete
            </b-button>
          </b-col>
        </b-row>    
      </b-form> 
    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
export default {
  props: {
    contact: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    deleteContact: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      form: {
        name: this.contact.name,
        job_title: this.contact.job_title,
        email: this.contact.email ? this.contact.email.toLowerCase() : null,
        telephone: this.contact.telephone
      }
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      job_title: {
        required
      },
      email: {
        required, email
      },
      telephone: {
        required
      },
    }  
  },
 
  methods: {
    
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
     ...mapActions({
      updatePerson: 'profile/updateProfilePersonAction',
    }),
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      return this.form
    }
  }
}
</script>

<style scoped>
@import "./style.scss";
</style>
